import React from 'react';

export default function(props) {
    return (
        <span
            className="mdl-navigation__link mdl-typography--text-uppercase"
            onClick={props.onClick}
        >
            {props.children}
        </span>
    );

}
